export default "__VITE_ASSET__DSGBcx_1__"